import { render, staticRenderFns } from "./Talks.vue?vue&type=template&id=2caea9e8&"
import script from "./Talks.vue?vue&type=script&lang=js&"
export * from "./Talks.vue?vue&type=script&lang=js&"
import style0 from "./Talks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports